module.exports = __webpack_public_path__ + "img/product_53.f8a7781.webp";